import { NgModule } from '@angular/core';

import { PurchaseOrderStatusPipe } from './purchase-order.status.pipe';

@NgModule({
  declarations: [
    PurchaseOrderStatusPipe
  ],
  providers: [
    PurchaseOrderStatusPipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'purchaseOrderStatus',
      useClass: PurchaseOrderStatusPipe
    }
  ]
})
export class PurchaseOrdersModule {}